export default {
  front: "Gerade aus",
  back: "Zurück",
  right: "Nach rechts",
  left: "Nach links",
};
